<template>
  <div id="app">
    <meta name="theme-color" content="#0267D1"/>
    <router-view/>
    <Loading v-if="$store.state.loading" />
    <Alert :msg="$store.state.alert.msg" :type="$store.state.alert.type"/>
    <AuthCheck v-if="$store.state.auth_check.type"/>
    <ConfimBox v-if="$store.state.confim_box.type"/>
    <PosSound v-if="$store.state.sound"/>
  </div>
</template>
<script>
import Loading from './components/Loading.vue'
import Alert from './components/Alert.vue'
import ConfimBox from './components/ConfimBox.vue'
import AuthCheck from './components/AuthCheck.vue'
import PosSound from './components/PosSound.vue'
export default {
  name: 'App',
  data () {
    return {
      page: 'load'
    }
  },
  created: function () {
    //判断当前APP类型
    let app_type = localStorage.getItem('app_type');
    if(app_type){
      this.$store.commit('setApp',app_type);
    }else{
      this.$store.commit('setApp','Main');
    }

    //如果不是登录页面
    if(this.$router.currentRoute.path !== '/Login'){
      //判断是否存在token
      var token = localStorage.getItem('token');
      if(token){
        //判断是否不存在用户记录
        var account = this.$store.state.account;
        if(Object.keys(account).length === 0){
          this.getAccount();
        }

        //加载参数
        let pos_args = localStorage.getItem('pos');
        if(pos_args){
          this.$store.commit('setPos',JSON.parse(pos_args));
        }

        let app_args = localStorage.getItem('app_args');
        if(app_args){
          this.$store.commit('setAppArgs',JSON.parse(app_args));
        }
        //console.log(account);
      }else{
        this.$store.commit('setAppArgs',{});
        this.$router.push({name: 'Login'});
      }
    }
    this.$store.commit('setBodyH', this);
  },
  mounted() {
    //console.log('APP-mounted');
    window.addEventListener('resize', this.handleResize);
  },
  watch: {
    /*
    '$route' (to, from) {   
          this.$router.go(0);
      }
    */
	},
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    onDecode(result) {
      console.log('Barcode result: ' + result);
    },
    onLoaded() {
      console.log('Barcode reader loaded');
    },
    //获取用户信息
    getAccount(){
      let post_data = { 
        app_type: this.$store.state.app_type
      };
      this.post(this.api_url + 'manage/account_data',post_data,true).then((res)=>{
        console.log(res);
        this.$store.commit('setAccount',res.data);
        if(this.$router.currentRoute.path == '/'){
          this.$router.push({name: this.$store.state.app_type});
        }
      });
    },
    handleResize() {
      //console.log(this.$refs)
      if (this.$refs.hasOwnProperty('app_head')) {
        var tb_h = this.$refs.app_head.offsetHeight + this.$refs.app_foot.offsetHeight;
        var body_h = window.innerHeight - tb_h;
        console.log(body_h);
      }
    },
  },
  components: {
    Loading,
    Alert,
    AuthCheck,
    ConfimBox,
    PosSound
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue